<template>
  <div class="MilestoneBonusElementList container-fluid margin-Top-Bottom-1Point5Perc" v-bind:class="{'bottom-dotted-border': (this.getBonusElementList.length > this.bonusElementObj.DisplayIndex)}">    
    <div class="admin-Panel-Padding">
      <div class="row vertical-align">
        <div class="col-md-2 col-lg-2">
        </div>
        <div class="col-md-1 col-lg-1">
          <input type="checkbox" value="true" v-model="getIsBonusElementSelected">
        </div>
        <div class="col-md-8 col-lg-8">
            <div class="row vertical-align">
              <div class="col-sm-1 col-md-1 col-lg-1 ">
                <img :src="elementImgSrc" class="element-icon-width-height" alt="element-icon">
              </div>
              <div class="col-sm-5 col-md-5 col-lg-5 padding-left-0Perc padding-right-0Perc text-align-left blue-text-color">
                <span class="element-type-font-style element-title-text-size">{{elementType}} </span> 
                <span v-if="bonusElementObj.Type !== 7" class="element-title-text-size">
                  / {{bonusElementObj.Duration}}
                </span>
                <span class="tooltip1 margin-0px cursor-default">
                  <img :src="bonusIcon" class="include-in-progress-width-height" alt="bonusIcon">  
                  <span class="tooltiptext1">{{getIsBonusContentTooltipValue}}</span>
                </span> 
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6">
              </div>
            </div> 
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-left blue-text-color element-name-text-size element-name-style">
                {{bonusElementObj.Title}}
              </div>
            </div>        
        </div>
        <div class="col-md-1 col-lg-1">
        </div>  
      </div>
    </div>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
  </div>    
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import videoiconblue from '../assets/images/iconvideoblue.svg'
import bonusicon from '../assets/images/bonus.svg'
import indexOf from 'lodash/indexOf'
export default {
  props: ['lessonObj', 'elementObj', 'elementList', 'bonusElementObj', 'bonusElementList'],
  name: 'MilestoneBonusElementList',
  created () {
    this.updateIsBonusElementSelectedFlag()
  },
  data: function () {
    return {
      includeInProgressTooltip: '',
      isBonusContentTooltip: 'Bonus Element',
      elementImgSrc: videoiconblue,
      elementType: 'Bonus Video',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      bonusIcon: bonusicon,
      isBonusElementSelected: false
    }
  },
  methods: {
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateIsBonusElementSelectedFlag: function () {
      var indexNo = indexOf(this.getElementIdsToComplete, this.bonusElementObj.ElementId)
      this.getIsBonusElementSelected = indexNo > -1
    },
    addOrRemoveElementIdFromList: function () {
      var _this = this
      if (this.getIsBonusElementSelected) {
        // AK: Check weather is already present current Element Id (Somehow)?
        var indexNo = indexOf(_this.$store.state.elementIdsToComplete, this.bonusElementObj.ElementId)
        if (indexNo === -1) {
          _this.$store.state.elementIdsToComplete.push(this.bonusElementObj.ElementId)
        }
        console.log('Adding current Bonus Step: ' + this.$store.state.elementIdsToComplete.length)
      } else {
        // AK: Check weather is already present current Element Id?
        indexNo = indexOf(_this.$store.state.elementIdsToComplete, this.bonusElementObj.ElementId)
        if (indexNo > -1) {
          _this.$store.state.elementIdsToComplete.splice(indexNo, 1)
        } else {
          // console.log('Already removed from list')
        }
        console.log('Removing current Bonus Steps: ' + this.$store.state.elementIdsToComplete.length)
      }
    }
  },
  components: {
    'alert-box': AlertBox
  },
  watch: {
    getIsBonusElementSelected: function (newValue, oldValue) {},
    getElementIdsToComplete: function (newValue, oldValue) {
      this.updateIsBonusElementSelectedFlag()
    }
  },
  computed: {
    getElementIdsToComplete: {
      get: function () {
        return this.$store.state.elementIdsToComplete
      }
    },
    getIsBonusElementSelected: {
      get: function () {
        return this.isBonusElementSelected
      },
      set: function (newValue) {
        this.isBonusElementSelected = newValue
        this.addOrRemoveElementIdFromList()
      }
    },
    getBonusElementList: {
      get: function () {
        return this.bonusElementList
      }
    },
    getElementList: {
      get: function () {
        return this.elementList
      }
    },
    getIsBonusContentTooltipValue: {
      get: function () {
        return this.isBonusContentTooltip
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default;
}
.opacity-point-2 {
  opacity: 0.5;
}
.opacity-point-5 {
  opacity: 0.9;
}
.left-icon-div {
  float: left;
  width: 5%;
}
.right-element-duration-div {
  float: right;
  width: 83%;
}
.middle-element-type-name-div {
  margin: 0 auto;
}
.element-type-font-style {
  font-weight: bold;
}
.element-icon-width-height {
  width: 19px;
  height: 19px;
}
.include-in-progress-width-height {
  width: 20px;
  height: 17px;
}
.padding-top-5px {
  padding-top: 5px;
}
.element-index-font-style {
  font-size: 19px;
  color: #ffffff;
}
.element-index-circle-width-height {
  width: 35px;
  height: 35px;
  background-color: #f39c12;
}
.roundered-corner {
  border-radius: 17.5px;
}
.MilestoneElementList {
  width: 90%;
}
.element-name-style {
  font-weight: lighter;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 18px;
  height: 22px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.element-name-text-size {
  font-size: 14px;
}
.element-title-text-size {
  font-size: 12px;
}
.orange-text-color {
  color: #f39c12;
}
.blue-text-color {
  color: #34495e;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.padding-right-0Perc{
  padding-right: 0%;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.width-5Perc{
  width: 5%;
}
.float-left{
  float: left;
}
.margin-5Perc {
  margin:5%;
}
.tooltip1 {
    position: relative;
    /* display: inline-block; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0.5px;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 140%;
    margin-left: -60px;
    font-size: 11px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.margin-right-0px {
  margin-right: 0px;
}
.margin-0px {
  margin: 0px;
}
.margin-left-2px {
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/MilestoneBonusElementList.vue